__turbopack_context__.v({
  "isInvalid": "RVlPgq_isInvalid",
  "root": "RVlPgq_root",
});
